module.exports = __webpack_public_path__ + "static/media/technologies.4dadfc28.png";